import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

import firebase from 'firebase'
import 'firebase/firestore'
import {config} from '@/config/firebaseConfig'
import isThisMonth from 'date-fns/is_this_month'
import Lifts from '@/liftTypes.js'
//import NamedWods from '@/wods-named.js'

firebase.initializeApp(config)

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
      user: {},
      authUser: {},
      workouts: [], //these only the last 30 workouts
      allWorkouts: [],
      db: firebase.firestore(),
      liftTypes: [],
      namedWods: []
    },
    getters: {
      userId: function(state) {
          return state.authUser.uid
      },
      score: state => {
        let rxWorkouts = 0
        let scaledWorkouts = 0
        state.workouts.forEach(workout => {
          if(workout.rx){
            rxWorkouts += 2
          } else {
            scaledWorkouts += 1
          }
        })
        return rxWorkouts + scaledWorkouts
      },
      scoreThisMonth: state => {
        let rxWorkouts = 0
        let scaledWorkouts = 0
        let thisMonthWorkouts = state.workouts.filter(workout => {
          return isThisMonth(workout.date)
        })
        thisMonthWorkouts.forEach(workout => {
          if(workout.rx){
            rxWorkouts += 2
          } else {
            scaledWorkouts += 1
          }
        })
      return rxWorkouts + scaledWorkouts
      },
      workoutsThisMonth: state => {
        let thisMonthWorkouts = state.workouts.filter(workout => {
          return isThisMonth(workout.date)
        })
        return thisMonthWorkouts.length
      },
      totalWorkouts: state => {
        return state.allWorkouts.length
      },
      workoutDates: state => {
        let dates = state.allWorkouts.map(workout => {
          let desc = ""
          if (workout.isNamedWod) {
            desc = workout.namedWod.name
          } else {
            desc = workout.description
          }
          return {'date': workout.date, 'type': workout.workoutType, 'id': workout.id, 'desc': desc } 
        })
        return dates
      }
    },
    mutations: {
      setUser: function(state, user) {
        state.user = user
      },
      setAuthUser: function(state) {
        state.authUser = firebase.auth().currentUser
      },
      setWorkouts: function(state) {
        let workoutsCollection = state.db.collection('users').doc(state.authUser.uid).collection('workouts')
        workoutsCollection.orderBy('date', 'desc').limit(30).get()
        .then(querySnapshot => {
          let workouts = []
          querySnapshot.forEach(doc => {
            let thisWorkout = doc.data()
            thisWorkout['id'] = doc.id
            workouts.push(thisWorkout)
          })
          state.workouts = workouts
        })
        .catch(err => {
          console.log(`Error getting workouts. Err: ${err}`)
        })
      },
      setAllWorkouts: function(state) {
        let workoutsCollection = state.db.collection('users').doc(state.authUser.uid).collection('workouts')
        workoutsCollection.orderBy('date', 'desc').get()
        .then(querySnapshot => {
          let workouts = []
          querySnapshot.forEach(doc => {
            let thisWorkout = doc.data()
            thisWorkout['id'] = doc.id
            workouts.push(thisWorkout)
          })
          state.allWorkouts = workouts
        })
        .catch(err => {
          console.log(`Error getting all workouts. Err: ${err}`)
        })
      },
      setBgColor: function(state, color) {
        state.user.bgColor = color
      },
      updateUser: function(state) {
        //console.log(state.user)
        state.db.collection('users').doc(state.authUser.uid).set(state.user)
        .then(() => {
          console.log("User successfully written!")
        })
        .catch((error) => {
          console.error("Error writing document: ", error)
        })
      },
      resetStore: function(state) {
        state.user = {},
        state.authUser = {},
        state.workouts = []
      },
      setLiftTypes: function (state) {
        //this sorts the lift alphabetically by 'name' key
        let importedLifts = Lifts.lifts.sort((a,b) => {
          const nameA = a.name.toUpperCase()
          const nameB = b.name.toUpperCase()
        
          let comparison = 0;
          if (nameA > nameB) {
            comparison = 1;
          } else if (nameA < nameB) {
            comparison = -1;
          }
          return comparison;
        })
        this.state.liftTypes = importedLifts
      },
      setNamedWods: function (state) {
        let namedWodsCollection = state.db.collection('namedWods')
        namedWodsCollection.orderBy('name', 'asc').get()
        .then(querySnapshot => {
          let returnedWods = []
          let counter = 0
          querySnapshot.forEach(doc => {
            let thisWod = doc.data()
            thisWod['id'] = doc.id
            returnedWods.push(thisWod)
            counter++
            if(counter == querySnapshot.size){
              //console.log("counter equals number of docs")
              state.namedWods = returnedWods
            }
          })
          //console.log(querySnapshot)
          
        })
      },
      /*
      uploadNamedWorkouts: function (state) {
        let counter = 0
        let namedWodsCollection = state.db.collection('namedWods')
        state.namedWods.forEach(wod => {
          namedWodsCollection.add(wod)
          .then(wod => {
            counter++
            if(counter == state.namedWods.length){
              console.log(`${counter} wods uploaded.`)
            }
          })
          .catch(err => {
            console.log(`Err: ${err}`)
          })
        })
        
      }*/

    }, //End Mutations
    actions: {
      ///Admin Actions ///
      addWod ({ commit, state }, wodPayload) {
        let namedWodsCollection = state.db.collection('namedWods')
        
        return new Promise((resolve, reject) => {
            namedWodsCollection.add(wodPayload)
            .then(wod => {
              console.log(`Wod Added with Id: ${wod.id}`)
              commit('setNamedWods')
            })
            .catch(err => {
              console.log(`Woops: ${err}`)
            })
            resolve()
        })   
      },
      ///--- END Admin Actions ///
      saveNewWorkout ({ commit, state }, workoutPayload) {
        let workoutCollection = state.db.collection('users').doc(state.authUser.uid).collection('workouts')
        
        return new Promise((resolve, reject) => {
            workoutCollection.add(workoutPayload)
            .then(workout => {
              console.log(`Workout Added with Id: ${workout.id}`)
              commit('setWorkouts')
              router.push({path: '/home'})
              commit('setAllWorkouts')
            })
            .catch(err => {
              console.log(`Woops: ${err}`)
            })
            resolve()
        })   
      },
      deleteWorkout ({ commit, state}, workoutId) {
        console.log(`workoutid to delete is: ${workoutId}`)
        let workoutCollection = state.db.collection('users').doc(state.authUser.uid).collection('workouts')

        return new Promise((resolve, reject) => {
          workoutCollection.doc(workoutId).delete()
          .then(() => {
            console.log('Workout Deleted')
            commit('setWorkouts')
            router.push({path: '/home'})
            commit('setAllWorkouts')
          })
          .catch(err => {
            alert('Woops... Something went wrong.')
            console.log(`Error: ${err}`)
          })
          resolve()
        })
        
      },
      updateWorkout ({ commit, state}, workoutPayload) {
        let id = workoutPayload.workoutId
        let workout = workoutPayload.workout
        
        if (!workout.pr){
          workout.pr = false
        } 
        if (!workout.rx){
          workout.rx = false
        }
        if (!workout.oneRepMax){
          workout.oneRepMax = false
        }

        return new Promise((resolve, reject) => {
          state.db.collection('users').doc(state.authUser.uid).collection('workouts').doc(id).set(workout)
          .then(() => {
            console.log(`Workout ${id} updated Successfully.`)
            commit('setWorkouts')
            router.go(-1)
            commit('setAllWorkouts')
          })
          .catch(err => {
            console.log(`Woops error updateing workout. Err: ${err}`)
          })
          resolve()
        })
        
        
      },
    } // End Actions
})




// WEBPACK FOOTER //
// ./src/store/index.js